export default __webpack_public_path__ + "static/media/IconHumidity.9a0572b5.svg";